import { useTranslation } from 'react-i18next';
import { setLocale } from '../../i18n';

export function LanguageSwitch({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const next = i18n.language === 'ar' ? 'en' : 'ar';
  return (
    <button type="button" className={className} onClick={() => setLocale(next)} lang={next}>
      {t('settings.switchLanguage')}
    </button>
  );
}
